export enum ProductDisplayDirection {
  VERTICAL = 'VERTICAL',
  HORIZONTAL = 'HORIZONTAL',
}

export interface ProductItemProps {
  productName: string;
  productDescription?: string;
  productQuantity?: number;
  productImageUrl?: string;
  className?: string;
  direction?: ProductDisplayDirection;
}
